var _a;
/** @hidden */
export var weekViewTitle = 'gantt.weekViewTitle';
/** @hidden */
export var dayViewTitle = 'gantt.dayViewTitle';
/** @hidden */
export var monthViewTitle = 'gantt.monthViewTitle';
/** @hidden */
export var yearViewTitle = 'gantt.yearViewTitle';
/** @hidden */
export var filterClearButton = 'gantt.filterClearButton';
/** @hidden */
export var filterEqOperator = 'gantt.filterEqOperator';
/** @hidden */
export var filterNotEqOperator = 'gantt.filterNotEqOperator';
/** @hidden */
export var filterIsNullOperator = 'gantt.filterIsNullOperator';
/** @hidden */
export var filterIsNotNullOperator = 'gantt.filterIsNotNullOperator';
/** @hidden */
export var filterIsEmptyOperator = 'gantt.filterIsEmptyOperator';
/** @hidden */
export var filterIsNotEmptyOperator = 'gantt.filterIsNotEmptyOperator';
/** @hidden */
export var filterStartsWithOperator = 'gantt.filterStartsWithOperator';
/** @hidden */
export var filterContainsOperator = 'gantt.filterContainsOperator';
/** @hidden */
export var filterNotContainsOperator = 'gantt.filterNotContainsOperator';
/** @hidden */
export var filterEndsWithOperator = 'gantt.filterEndsWithOperator';
/** @hidden */
export var filterGteOperator = 'gantt.filterGteOperator';
/** @hidden */
export var filterGtOperator = 'gantt.filterGtOperator';
/** @hidden */
export var filterLteOperator = 'gantt.filterLteOperator';
/** @hidden */
export var filterLtOperator = 'gantt.filterLtOperator';
/** @hidden */
export var filterIsTrue = 'gantt.filterIsTrue';
/** @hidden */
export var filterIsFalse = 'gantt.filterIsFalse';
/** @hidden */
export var filterBooleanAll = 'gantt.filterBooleanAll';
/** @hidden */
export var filterAfterOrEqualOperator = 'gantt.filterAfterOrEqualOperator';
/** @hidden */
export var filterAfterOperator = 'gantt.filterAfterOperator';
/** @hidden */
export var filterBeforeOperator = 'gantt.filterBeforeOperator';
/** @hidden */
export var filterBeforeOrEqualOperator = 'gantt.filterBeforeOrEqualOperator';
/** @hidden */
export var noRecords = 'gantt.noRecords';
/** @hidden */
export var editorSave = 'gantt.editSave';
/** @hidden */
export var editorCancel = 'gantt.editCancel';
/** @hidden */
export var editorTitle = 'gantt.editorTitle';
/** @hidden */
export var editorTaskTitle = 'gantt.editorTaskTitle';
/** @hidden */
export var editorTaskStart = 'gantt.editorTaskStart';
/** @hidden */
export var editorTaskEnd = 'gantt.editorTaskEnd';
/** @hidden */
export var editorTaskComplete = 'gantt.editorTaskComplete';
/** @hidden */
export var editorValidationRequired = 'gantt.editorValidationRequired';
/** @hidden */
export var editorValidationStart = 'gantt.editorValidationStart';
/** @hidden */
export var editorValidationEnd = 'gantt.editorValidationEnd';
/** @hidden */
export var addTask = 'gantt.addTask';
/** @hidden */
export var addChild = 'gantt.addChild';
/** @hidden */
export var addAbove = 'gantt.addAbove';
/** @hidden */
export var addBelow = 'gantt.addBelow';
/** @hidden */
export var editorDelete = 'gantt.editorDelete';
/** @hidden */
export var deleteConfirmation = 'gantt.deleteConfirmation';
/** @hidden */
export var deleteDialogTitle = 'gantt.deleteDialogTitle';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[weekViewTitle] = 'Week',
    _a[dayViewTitle] = 'Day',
    _a[monthViewTitle] = 'Month',
    _a[yearViewTitle] = 'Year',
    _a[filterClearButton] = 'Clear',
    _a[filterEqOperator] = 'Is equal to',
    _a[filterNotEqOperator] = 'Is not equal to',
    _a[filterIsNullOperator] = 'Is null',
    _a[filterIsNotNullOperator] = 'Is not null',
    _a[filterIsEmptyOperator] = 'Is empty',
    _a[filterIsNotEmptyOperator] = 'Is not empty',
    _a[filterStartsWithOperator] = 'Starts with',
    _a[filterContainsOperator] = 'Contains',
    _a[filterNotContainsOperator] = 'Does not contain',
    _a[filterEndsWithOperator] = 'Ends with',
    _a[filterGteOperator] = 'Is greater than or equal to',
    _a[filterGtOperator] = 'Is greater than',
    _a[filterLteOperator] = 'Is less than or equal to',
    _a[filterLtOperator] = 'Is less than',
    _a[filterIsTrue] = 'Is true',
    _a[filterIsFalse] = 'Is false',
    _a[filterBooleanAll] = '(All)',
    _a[filterAfterOrEqualOperator] = 'Is after or equal to',
    _a[filterAfterOperator] = 'Is after',
    _a[filterBeforeOperator] = 'Is before',
    _a[filterBeforeOrEqualOperator] = 'Is before or equal to',
    _a[noRecords] = 'No records available',
    _a[editorSave] = 'Save',
    _a[editorCancel] = 'Cancel',
    _a[editorTitle] = 'Task',
    _a[editorTaskTitle] = 'Title',
    _a[editorTaskStart] = 'Start',
    _a[editorTaskEnd] = 'End',
    _a[editorTaskComplete] = 'Complete',
    _a[editorValidationRequired] = 'Field is required.',
    _a[editorValidationStart] = 'Start time must be be before End time.',
    _a[editorValidationEnd] = 'End time must be after Start time.',
    _a[addTask] = 'Add Task',
    _a[addChild] = 'Add Child',
    _a[addAbove] = 'Add Above',
    _a[addBelow] = 'Add Below',
    _a[editorDelete] = 'Delete',
    _a[deleteConfirmation] = 'Are you sure you want to delete this event?',
    _a[deleteDialogTitle] = 'Delete Event',
    _a);
